import API_URLS from '@Constants/apiUrls.constants';
import { DncAdd, DncEdit, DncFilters, DncList } from '@Models/dnc.models';

import { baseApi } from './baseApi.service';

const {
  DNC: { PHONE, PHONES, RESTORE, BASE, BASE_DNC, VIEW },
} = API_URLS;

const getModalFilters = (dncId: string, accountId?: number) => {
  const filters: DncFilters[] = [
    {
      operationType: 'EQUALS',
      propertyName: 'ID',
      dateRangeValue: null,
      value: dncId,
    },
  ];

  if (accountId) {
    filters.push({
      operationType: 'EQUALS',
      propertyName: 'ACCOUNT_ID',
      dateRangeValue: null,
      value: accountId,
    });
  }

  return filters;
};

export const dncApi = baseApi
  .enhanceEndpoints({ addTagTypes: ['DNC'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getDnc: builder.query<
        DncList,
        {
          dncId: string;
          accountId?: number;
        }
      >({
        query: ({ dncId, accountId }) => ({
          url: `${BASE}/${PHONES}/${VIEW}`,
          method: 'POST',
          body: {
            filters: getModalFilters(dncId, accountId),
          },
        }),
        providesTags: ['DNC'],
      }),

      getDncList: builder.query<DncList, DncList>({
        query: (body) => ({
          url: `${BASE}/${PHONES}/${VIEW}`,
          method: 'POST',
          body,
        }),
        providesTags: ['DNC'],
      }),

      restoreDncRow: builder.mutation<DncList, string>({
        query: (id) => ({
          url: `${BASE}/${PHONE}/${RESTORE}/${id}`,
          method: 'PUT',
          body: id,
        }),
        invalidatesTags: ['DNC'],
      }),

      deleteDncRows: builder.mutation<DncList, readonly string[]>({
        query: (ids) => ({
          url: `${BASE}/${PHONES}/${ids.join('%2C')}`,
          method: 'DELETE',
          body: ids.join(','),
        }),
        invalidatesTags: ['DNC'],
      }),

      editDncRow: builder.mutation<DncList, DncEdit>({
        query: ({ id, phone, reason, accountId, comments }) => ({
          url: `${BASE}/${PHONE}/${id}`,
          method: 'PUT',
          body: accountId
            ? {
                phone,
                reason,
                comments,
                accountId,
              }
            : {
                phone,
                reason,
                comments,
              },
        }),
        invalidatesTags: ['DNC'],
      }),

      addDncRow: builder.mutation<DncList, DncAdd>({
        query: ({ phone, reason, accountId, comments }) => ({
          url: `${BASE}/${PHONE}`,
          method: 'POST',
          body: accountId
            ? {
                phone,
                reason,
                comments,
                accountId,
              }
            : {
                phone,
                reason,
                comments,
              },
        }),
        invalidatesTags: ['DNC'],
      }),

      deleteBulkDncRows: builder.mutation<DncList, DncList>({
        query: (body) => ({
          url: `${BASE_DNC}/${PHONES}`,
          method: 'DELETE',
          body,
        }),
        invalidatesTags: ['DNC'],
      }),
    }),
  });

export const {
  useGetDncQuery,
  useGetDncListQuery,
  useRestoreDncRowMutation,
  useDeleteDncRowsMutation,
  useEditDncRowMutation,
  useAddDncRowMutation,
  useDeleteBulkDncRowsMutation,
} = dncApi;
